<template>
  <div class="course-library-add">
    <el-card>
      <div slot="header" class="clearfix">
        <span class="title">{{ offlineCourseId ? '编辑课程' : '创建课程' }}</span>
      </div>
      <el-form ref="form" :model="form" label-width="115px" :rules="rules">
        <el-form-item label="课程名称" prop="offlineCourseInfo.courseName">
          <el-input
            v-model="form.offlineCourseInfo.courseName"
            placeholder="请输入1-12个汉字课程名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="课程时长" prop="offlineCourseInfo.courseDuration">
          <el-input
            v-model="form.offlineCourseInfo.courseDuration"
            style="width:120px"
            oninput="value=value.replace(/[^\d.]/g,'')"
            placeholder="请输入课程时长"
            clearable
          ></el-input>
          <span style="margin-left:20px">天</span>
        </el-form-item>
        <el-form-item label="授课讲师" prop="teacherId">
          <el-input
            v-model="teacherName"
            placeholder="请输入授课讲师"
            disabled
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item ref="coursePic" label="课程封面图" prop="offlineCourseInfo.coursePic">
          <el-upload
            class="uploader"
            action=""
            :show-file-list="false"
            :before-upload="file => handleCoverBeforeUpload(file, 'coursePic')"
            accept=".jpg,.jpeg,.png,.JPG,.JPEG"
          >
            <img
              v-if="form.offlineCourseInfo.coursePic"
              :src="form.offlineCourseInfo.coursePic"
              class="cover-preview"
            />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
          <p class="tip">图片大小最好在564 X 290，支持扩展名：.png .jpg .jpeg</p>
        </el-form-item>
        <el-form-item label="课程简介" prop="offlineCourseInfo.courseDesc">
          <el-input
            v-model="form.offlineCourseInfo.courseDesc"
            type="textarea"
            :rows="5"
            placeholder="请输入课程简介"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="课程详细描述">
          <tinymce ref="editor" v-model="form.offlineCourseInfo.courseIntroduction"></tinymce>
        </el-form-item>
        <el-form-item label="授课见证名称" prop="teachingWitnessInfo.teachingWitnessName">
          <el-input
            v-model="form.teachingWitnessInfo.teachingWitnessName"
            placeholder="请输入授课见证名称(最多24个汉字)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item ref="teachingWitnessPic" label="封面图" prop="teachingWitnessPic">
          <el-upload
            class="uploader"
            action=""
            :show-file-list="false"
            :before-upload="file => handleCoverBeforeUpload(file, 'teachingWitnessPic')"
            accept=".jpg,.jpeg,.png,.JPG,.JPEG"
          >
            <img
              v-if="form.teachingWitnessInfo.teachingWitnessPic"
              :src="form.teachingWitnessInfo.teachingWitnessPic"
              class="cover-preview"
            />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
          <p class="tip">图片大小最好在564 X 290，支持扩展名：.png .jpg .jpeg</p>
        </el-form-item>
        <el-form-item label="授课见证描述">
          <tinymce
            ref="editor"
            v-model="form.teachingWitnessInfo.teachingWitnessIntroduction"
          ></tinymce>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="submit">{{
            offlineCourseId ? '确认保存' : '确认创建'
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <cropper-image-modal ref="cropperModal" @cropped="handleCropped"></cropper-image-modal>
  </div>
</template>
<script>
import { ceratedOfflineCourses, editOfflineCourses, searchOfflineCourses } from '@/api/teacher'
import { getFileUpload } from '@/api/college'
import to from 'await-to'
import CropperImageModal from '@/components/CropperImageModal'
import Tinymce from '@/components/Tinymce'
export default {
  components: { CropperImageModal, Tinymce },
  data() {
    return {
      rules: {
        'offlineCourseInfo.courseName': [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          { min: 1, max: 12, message: '请输入1~12个字', trigger: 'blur' },
        ],
        'teachingWitnessInfo.teachingWitnessName': [
          { min: 1, max: 24, message: '请输入1~24个字', trigger: 'blur' },
        ],
        'offlineCourseInfo.courseDuration': [
          { required: true, message: '请输入课程时长', trigger: 'blur' },
        ],
        // teacherName: [{ required: true, message: '请输入授课讲师', trigger: 'blur' }],
        'offlineCourseInfo.coursePic': [
          { required: true, message: '请上传课程封面图', trigger: 'change' },
        ],
        'offlineCourseInfo.courseDesc': [
          { min: 1, max: 128, message: '请输入1~128个字', trigger: 'blur' },
        ],
      },
      teacherName: this.$route.query.teacherName,
      form: {
        offlineCourseInfo: {
          teacherId: this.$route.query.teacherId,
          coursePic: '',
          courseName: '',
          courseIntroduction: '',
          courseDuration: '',
        },
        teachingWitnessInfo: {
          teachingWitnessIntroduction: '',
          teachingWitnessName: '',
          teachingWitnessPic: '',
        },
      },
      loading: false,
      offlineCourseId: '',
      currentCropField: '',
    }
  },
  mounted() {
    const { offlineCourseId } = this.$route.query
    this.offlineCourseId = offlineCourseId
    if (offlineCourseId) this.searchOfflineCourses()
  },
  methods: {
    //封面图上传前打开裁剪框
    handleCoverBeforeUpload(file, field) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        return false
      }
      this.currentCropField = field
      const reader = new FileReader()
      reader.onload = e => {
        this.$refs.cropperModal.open(e.target.result)
      }
      reader.readAsDataURL(file)
      return false
    },
    //裁剪后上传图片
    async handleCropped(file) {
      const params = new FormData()
      params.append('fileTypeCode', 'F001')
      params.append('file', file)
      params.append('fileName', file.name)
      const [res, err] = await to(getFileUpload(params))
      if (err) {
        return this.$message.error(err.msg)
      }
      if (this.currentCropField === 'coursePic') {
        this.$set(this.form.offlineCourseInfo, 'coursePic', res.data)
        this.$refs.coursePic.clearValidate()
      } else if (this.currentCropField === 'teachingWitnessPic') {
        this.$set(this.form.teachingWitnessInfo, 'teachingWitnessPic', res.data)
        this.$refs.teachingWitnessPic.clearValidate()
      }
    },
    async searchOfflineCourses() {
      const [res, err] = await to(searchOfflineCourses({ offlineCourseId: this.offlineCourseId }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.offlineCourseId ? this.update() : this.create()
        }
      })
    },
    async create() {
      this.loading = true
      const [, err] = await to(ceratedOfflineCourses(this.form))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('创建成功')
      this.$router.push({
        path: '/teacher/offlineCoursesList',
        query: {
          teacherId: this.form.offlineCourseInfo.teacherId,
          teacherName: this.teacherName,
        },
      })
    },
    async update() {
      this.loading = true
      const [, err] = await to(editOfflineCourses(this.form))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('修改成功')
      this.$router.push({
        path: '/teacher/offlineCoursesList',
        query: {
          teacherId: this.form.offlineCourseInfo.teacherId,
          teacherName: this.teacherName,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.course-library-add {
  .el-radio-button {
    margin-bottom: 20px;
  }
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  ::v-deep .uploader {
    height: 92px;
    .el-upload {
      width: 180px;
      height: 100%;
      background: #f5f5f5;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cover-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px;
    }
    .el-upload-list__item {
      width: 180px;
      height: 100%;
    }
    .el-icon-upload {
      font-size: 58px;
    }
  }
  ::v-deep .el-upload-dragger {
    background: #f5f5f5;
  }
}
</style>
